import { getStripeAmountToCharge } from '../../utils/utils'
import { z } from 'zod'
import {
  CheckoutResultSchema,
  GroupCheckoutResponseSchema,
} from '../../features/cart/groupCheckoutPricing.schemas'
import { formatPricingSummary } from '../Pricing/PricingUtil'
import { type CheckoutSummary } from '../Pricing/types/checkout.types'
import { applyGroupShippingOptionToSummary } from '../../features/cart/groupPricingSummary'

export type ExpressCheckoutRate = {
  id: string
  summary: CheckoutSummary
}

export type ExpressCheckoutPricing = {
  rates: ExpressCheckoutRate[]
}

const CheckoutResultsSchema = z.array(CheckoutResultSchema)

export function shapeExpressCheckoutSummary({
  checkoutResults,
  checkoutId,
  discountId,
  productType,
  originalProducts,
  promoCode,
}: {
  checkoutResults: unknown
  checkoutId: string
  discountId?: string | null
  productType: string
  originalProducts: unknown[]
  promoCode?: string
}): ExpressCheckoutPricing {
  const rates = CheckoutResultsSchema.parse(checkoutResults).map(
    (result): ExpressCheckoutRate => ({
      id: result.key,
      summary: formatPricingSummary({
        orderPriceSummary: result,
        currency: result.currency,
        checkoutId,
        discountId,
        promoCode,
        productType,
        originalProducts,
      }),
    })
  )
  return { rates }
}

export function shapeExpressCheckoutGroupSummary(
  response: unknown,
  basePricingSummary: CheckoutSummary
): ExpressCheckoutPricing {
  const groupPricing = GroupCheckoutResponseSchema.parse(response)
  const rates = Object.keys(groupPricing.shippingOptions).map(
    (id): ExpressCheckoutRate => ({
      id,
      summary: applyGroupShippingOptionToSummary(
        basePricingSummary,
        groupPricing,
        id
      ),
    })
  )
  return { rates }
}

export function findExpressCheckoutRateById(
  pricing: ExpressCheckoutPricing,
  rateId: string
) {
  return pricing.rates.find((rate) => rate.id === rateId)
}

export function getExpressCheckoutRateStripeAmount({
  summary,
}: ExpressCheckoutRate): number {
  return getStripeAmountToCharge({
    totalCost: summary.totalPrice,
    currency: summary.currency,
  })
}
